import React from "react";
import SkillCard from "../components/SkillCard";
import ExperienceCard from "../components/ExperienceCard";
import aboutImage from "../assets/images/about.jpg";

// Skills from Resume
const skills = [
  { title: "Web Development", level: 90 },
  { title: "AI Development", level: 85 },
  { title: "Network Design", level: 88 },
  { title: "Network Security", level: 80 },
  { title: "Cloud Computing", level: 75 },
  { title: "Teamwork", level: 95 },
];

// Experiences from Resume
const experiences = [
  {
    role: "Intern",
    company: "Ethiopian Customs Commission",
    period: "July 2025 - September 2025",
    description: "Worked on AI integration and network infrastructure improvement, developed an online maintenance request system, received a recommendation for outstanding contribution.",
    achievements: [
      "Developed an online maintenance request system",
      "Contributed to AI integration projects",
      "Improved network infrastructure",
      "Received recommendation for outstanding contribution"
    ]
  },
  {
    role: "Network Designer",
    company: "Addis Ababa University",
    period: "January 2025 - June 2025",
    description: "Designed and simulated a full enterprise network for the 4 Kilo campus with redundancy using Cisco HSRP, documented and presented the topology.",
    achievements: [
      "Designed full enterprise network topology",
      "Implemented redundancy using Cisco HSRP",
      "Created comprehensive network documentation",
      "Presented network design to stakeholders"
    ]
  },
  {
    role: "AI Enabled Web Developer",
    company: "Freelance - NGOs",
    period: "2024 - Present",
    description: "Designed AI enabled Websites for two non-governmental organizations - Tihut Organization and Power Plan Development Program.",
    achievements: [
      "Developed AI-powered web solutions",
      "Worked with Tihut Organization",
      "Worked with Power Plan Development Program"
    ]
  }
];

const About = () => {
  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement("img", {
      src: aboutImage, 
      alt: "Abate Alemu",
      style: styles.image,
    }),
    React.createElement(
      "div",
      { style: styles.bioContainer },
      React.createElement(
        "h1",
        { style: styles.heading },
        "About Me"
      ),
      React.createElement(
        "p",
        { style: styles.bio },
        "I am dedicated with strong skills in network design, AI development, and full-stack web development, eager to solve organizational challenges through innovative solutions. Currently pursuing my Bachelor of Science in Information Systems at Addis Ababa University (September 2022 - June 2026), I combine academic excellence with practical experience in enterprise network design, AI integration, and web development."
      )
    ),
    
    // Work Experience Section
    React.createElement(
      "div",
      { style: styles.experienceContainer },
      React.createElement(
        "h2",
        { style: styles.sectionHeading },
        "Work Experience"
      ),
      React.createElement(
        "div",
        { style: styles.experienceList },
        experiences.map((experience, index) =>
          React.createElement(ExperienceCard, {
            key: index,
            role: experience.role,
            company: experience.company,
            period: experience.period,
            description: experience.description,
            achievements: experience.achievements,
          })
        )
      )
    ),

    // Skills Section
    React.createElement(
      "div",
      { style: styles.skillsContainer },
      React.createElement(
        "h2", 
        { style: styles.skillsHeading },
        "My Skills"
      ),
      React.createElement(
        "div",
        { style: styles.skillsGrid },
        skills.map((skill, index) =>
          React.createElement(SkillCard, {
            key: index,
            title: skill.title,
            level: skill.level,
          })
        )
      )
    )
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "40px 20px",
    margin: "20px auto",
    maxWidth: "1200px",
  },
  image: {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    objectFit: "cover",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
    marginBottom: "30px",
    border: "4px solid #0077b6",
  },
  bioContainer: {
    flex: "1",
    marginBottom: "50px",
    maxWidth: "900px",
    background: "rgba(255, 255, 255, 0.95)",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    fontSize: "2.5rem",
    color: "#0077b6",
    marginBottom: "20px",
    fontWeight: "700",
  },
  bio: {
    fontSize: "1.1rem",
    color: "#333",
    lineHeight: "1.8",
    textAlign: "left",
  },
  experienceContainer: {
    width: "100%",
    maxWidth: "900px",
    marginBottom: "50px",
    background: "rgba(255, 255, 255, 0.95)",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  sectionHeading: {
    fontSize: "2rem",
    color: "#0077b6",
    marginBottom: "25px",
    fontWeight: "700",
    textAlign: "left",
  },
  experienceList: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  skillsContainer: {
    width: "100%",
    maxWidth: "900px",
    textAlign: "center",
    background: "rgba(255, 255, 255, 0.95)",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  skillsHeading: {
    fontSize: "2rem",
    color: "#0077b6",
    marginBottom: "25px",
    fontWeight: "700",
  },
  skillsGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
  },
};

export default About;
